<template>
  <div class="custom-pagination">
    <div class="d-flex align-center justify-space-between px-4">
      <div class="items-per-page d-flex align-center">
        <span class="mr-2 text-caption">Righe per pagina:</span>
        <v-select
            v-model="localItemsPerPage"
            :items="itemsPerPageOptions"
            dense
            hide-details
            class="items-per-page-select"
            @change="onItemsPerPageChange"
        ></v-select>
      </div>

      <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :total-visible="5"
          color="primary"
          @input="onPageChange"
          dense
      ></v-pagination>

      <div class="page-info text-caption">
        {{ totalItems > 0 ? (currentPage - 1) * localItemsPerPage + 1 : 0 }}-{{ Math.min(currentPage * localItemsPerPage, totalItems) }} di {{ totalItems }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomPagination",
  props: {
    value: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      currentPage: this.value,
      localItemsPerPage: this.itemsPerPage,
      itemsPerPageOptions: [5, 10, 25, 50, 100]
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.localItemsPerPage);
    }
  },
  watch: {
    value(newVal) {
      this.currentPage = newVal;
    },
    itemsPerPage(newVal) {
      this.localItemsPerPage = newVal;
    }
  },
  methods: {
    onPageChange(page) {
      this.$emit('input', page);
      this.$emit('page-changing', true); // Emettiamo un evento per indicare che la pagina sta cambiando
    },
    onItemsPerPageChange() {
      console.log('Items per page changed to:', this.localItemsPerPage);
      this.$emit('update:items-per-page', this.localItemsPerPage);
      // Reset to page 1 when changing items per page
      this.currentPage = 1;
      this.$emit('input', 1);
    }
  }
};
</script>

<style scoped>
.custom-pagination {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #f9fafc;
  padding: 8px 0;
}

.items-per-page-select {
  max-width: 80px;
}

.v-pagination {
  box-shadow: none !important;
}

.v-pagination button {
  min-width: 32px !important;
  height: 32px !important;
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  border-radius: 4px !important;
  margin: 0 2px !important;
}

.v-pagination button.v-pagination__item--active {
  background-color: var(--primary) !important;
  color: white !important;
}

.page-info {
  min-width: 100px;
  text-align: right;
  color: rgba(0, 0, 0, 0.6);
}
</style>
